<ng-container *ngIf="pickerValue">
  <!-- Date -->
  <mat-form-field *ngIf="mode === 'date'" appearance="outline">
    <input matInput [matDatepicker]="dp" [placeholder]="title" [formControl]="pickerValue" />
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker #dp></mat-datepicker>
  </mat-form-field>

  <!-- Hour -->
  <div fxLayout="row" fxLayoutGap="4" *ngIf="mode === 'time'">
    <span>{{ title }}</span>
    <input [ngxMatTimepicker]="pickerTime" [format]="24" [formControl]="pickerValue" [disabled]="true" />
    <ngx-mat-timepicker timepickerClass="ebo-clock" color="accent" #pickerTime></ngx-mat-timepicker>
    <mat-icon style="cursor: pointer" (click)="pickerTime.open()">schedule</mat-icon>
  </div>

  <!-- Date + Hour -->
  <mat-form-field *ngIf="mode === 'datetime'" appearance="outline">
    <input matInput [ngxMatDatetimePicker]="dtp" [placeholder]="title" [formControl]="pickerValue" />
    <ngx-mat-datetime-picker #dtp></ngx-mat-datetime-picker>
    <mat-datepicker-toggle matSuffix [for]="dtp"></mat-datepicker-toggle>
  </mat-form-field>
</ng-container>
